import { render, staticRenderFns } from "./PosPromotionCreateNew.vue?vue&type=template&id=47920126&scoped=true&"
import script from "./PosPromotionCreateNew.vue?vue&type=script&lang=js&"
export * from "./PosPromotionCreateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47920126",
  null
  
)

export default component.exports